import { useEffect } from 'react'
import styles from './ViewPalletLotModal.module.scss'
import BidMsrpButton from 'elements/BidMsrpButton/BidMsrpButton'
import Slider from 'react-slick'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

export default function ViewPalletLotModal({
  showModal,
  negativeZ,
  item,
  toggleModal,
}: any) {
  const tableHeadingList = ['#', 'Photo', 'Title', 'Brand', 'MSRP', 'Qty']

  const renderHeadingList = (list: any) => {
    return list.map((item: any) => (
      <th
        className="font-bold !bg-bidfta-blue-dark text-white py-4 text-xs px-4 border-r md:border-none border-bidfta-gray-border"
        key={item}
      >
        {item}
      </th>
    ))
  }

  useEffect(() => {
    const closeModal = (e: any) => {
      if (e.key === 'Escape') {
        toggleModal(false, 'View')
      }
    }
    window.addEventListener('keyup', closeModal)
    return () => window.removeEventListener('keyup', closeModal)
  }, []) // eslint-disable-line
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  }

  return (
    <div
      className={`transition-opacity duration-200 fixed top-0 flex justify-center items-center w-full h-screen p-4 bg-black/30 ${
        negativeZ ? styles.hide_modal : 'z-50'
      } ${!showModal ? ` opacity-0` : 'opacity-100'}`}
      role="none"
      onClick={() => toggleModal(false, 'View')}
    >
      <div
        className={`${styles.modal} relative p-8 md:p-0 bg-white rounded-lg max-h-full	overflow-y-scroll`}
        role="none"
        onClick={(e: any) => e.stopPropagation()}
      >
        <button
          className="absolute top-0 right-0 px-3 py-1 text-xl md:hidden"
          type="button"
          onClick={() => toggleModal(false, 'View')}
        >
          &times;
        </button>
        <div className="md:grid md:gap-3">
          {/* Mobile Layout */}
          <div className="md:hidden">
            <Slider {...settings}>
              {item.palletLotList.map((lineItem: any, index: number) => (
                <div key={`line-item-${index}`}>
                  <table key={lineItem.id} className="mx-auto">
                    <tbody className="px-4 w-full border border-bidfta-gray-border text-sm">
                      {/* # */}
                      <tr className="border-b border-bidfta-gray-border py-2">
                        <td className="font-bold text-xs px-4 border-r border-bidfta-gray-border w-26">
                          #
                        </td>
                        <td className="text-bidfta-gray-dark/60 p-2">
                          {index + 1}
                        </td>
                      </tr>
                      {/* Image */}
                      <tr className="border-b border-bidfta-gray-border py-2">
                        <td className="font-bold text-xs px-4 border-r border-bidfta-gray-border w-26">
                          Photo
                        </td>
                        <td className="text-bidfta-gray-dark/60 p-2 w-[100px] h-[100px] rounded-md">
                          <img
                            src={lineItem.imageUrl}
                            alt={lineItem.title}
                            className="w-full h-full object-fill rounded-md"
                          />
                        </td>
                      </tr>
                      {/* Title */}
                      <tr className="border-b border-bidfta-gray-border py-2">
                        <td className="font-bold text-xs px-4 border-r border-bidfta-gray-border w-26">
                          Title
                        </td>
                        <td className="text-bidfta-gray-dark/60 p-2">
                          {lineItem.title}
                        </td>
                      </tr>
                      {/* Brand */}
                      <tr className="border-b border-bidfta-gray-border py-2">
                        <td className="font-bold text-xs px-4 border-r border-bidfta-gray-border w-26">
                          Brand
                        </td>
                        <td className="text-bidfta-gray-dark/60 p-2">
                          {lineItem.brand ? lineItem.brand : 'N/A'}
                        </td>
                      </tr>
                      {/* MSRP */}
                      <tr className="border-b border-bidfta-gray-border py-2">
                        <td className="px-4 border-r border-bidfta-gray-border w-26">
                          <div className="flex items-center">
                            <h4 className="font-bold text-xs mr-1">MSRP</h4>
                            <BidMsrpButton />
                          </div>
                        </td>
                        <td className="text-bidfta-gray-dark/60 p-2">
                          {lineItem.msrp
                            ? `$${lineItem.msrp?.toFixed(2)}`
                            : 'N/A'}
                        </td>
                      </tr>
                      {/* Qty */}
                      <tr className="border-b border-bidfta-gray-border bg-bidfta-green-tablelight py-2">
                        <td className="font-bold text-xs px-4 border-r border-bidfta-gray-border p-2 w-26">
                          Qty
                        </td>
                        <td className="text-bidfta-gray-dark/60 p-2">
                          {lineItem.quantity ? lineItem.quantity : 'N/A'}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ))}
            </Slider>
          </div>
          {/* Desktop Layout */}
          <table className="hidden md:block desktop-table md:p-8">
            <thead>
              <tr className="border-b border-bidfta-gray-border py-2">
                {renderHeadingList(tableHeadingList)}
              </tr>
            </thead>
            <tbody className="px-4 w-full border border-bidfta-gray-border">
              {item.palletLotList.map((lineItem: any, index: number) => (
                <tr
                  key={lineItem.id}
                  className={`border-b border-bidfta-gray-border text-center ${
                    index % 2 ? 'bg-bidfta-green-tablelight' : ''
                  } py-2`}
                >
                  {/* Title */}
                  <td className="text-bidfta-gray-dark/60 p-2 font-bold">
                    {index + 1}
                  </td>
                  {/* Image */}
                  <td className="text-bidfta-gray-dark/60 p-2 w-[100px] h-[100px] rounded-md">
                    <img
                      src={lineItem.imageUrl}
                      alt={lineItem.title}
                      className="w-full h-full object-fill rounded-md"
                    />
                  </td>
                  {/* Title */}
                  <td className="text-bidfta-gray-dark/60 p-2 text-left">
                    {lineItem.title}
                  </td>
                  {/* Brand */}
                  <td className="text-bidfta-gray-dark/60 p-2">
                    {lineItem.brand ? lineItem.brand : 'N/A'}
                  </td>
                  {/* MSRP */}
                  <td className="text-bidfta-gray-dark/60 p-2">
                    {lineItem.msrp ? `$${lineItem.msrp?.toFixed(2)}` : 'N/A'}
                  </td>
                  {/* Qty */}
                  <td className="text-bidfta-gray-dark/60 p-2">
                    {lineItem.quantity ? lineItem.quantity : 'N/A'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}
